// extracted by mini-css-extract-plugin
module.exports = {"root":"SimpleLineChart_root__oQWuR","buttons":"SimpleLineChart_buttons__2J1qQ"};